import { Button, Heading, VStack } from "@chakra-ui/react";

import { Tenant } from "@nens/ldo/auth-v1";

interface ChooseTenantProps {
  tenants: Tenant[];
  setTenant: (tenant: Tenant) => void;
}

export function ChooseTenant({ tenants, setTenant }: ChooseTenantProps) {
  return (
    <VStack>
      <Heading>Choose a tenant to log in to</Heading>
      {tenants.map((tenant) => (
        <Button key={tenant.id} onClick={() => setTenant(tenant)}>
          {tenant.name}
        </Button>
      ))}
    </VStack>
  );
}
